import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './legal-practitioner-form.component.scss';
import * as $ from "jquery";
var LegalPractitionerForm = /** @class */ (function (_super) {
    tslib_1.__extends(LegalPractitionerForm, _super);
    function LegalPractitionerForm(element) {
        return _super.call(this, element) || this;
    }
    LegalPractitionerForm.prototype.init = function () {
        this.form = this.element.querySelector("form");
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        this.buttonSubmit = this.element.querySelector(".js-fleet__button--submit");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        // buttons
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        this.formDatePicker = this.element.querySelector('.js-date-picker');
        this.formTimePicker = this.element.querySelector('.js-time-picker');
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.populateDatePicker();
        this.publicHolidays = ['2018/01/01', '2018/03/21', '2018/03/30', '2018/04/02', '2018/04/27', '2018/05/01', '2018/06/16', '2018/08/09', '2018/09/24', '2018/12/16', '2018/12/17', '2018/12/25', '2018/12/26'];
    };
    LegalPractitionerForm.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _button = pEvent.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function (event) {
                _this.form.reset();
                window.location.href = '/southafrica/business/products-and-services/business-solutions/industry/legal-professional-solutions';
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm("close"); });
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
    };
    LegalPractitionerForm.prototype.populateDatePicker = function () {
        if (this.formDatePicker) {
            this._startDate = this.validateDate();
            $(this.formDatePicker).datepicker('setStartDate', this._startDate);
        }
    };
    LegalPractitionerForm.prototype.submitForm = function (form) {
        var _this = this;
        var _email = form.querySelector("input[name=email]");
        var _product = form.querySelector("input[name=product]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _firstname = form.querySelector("input[name=first-name]");
        var _surname = form.querySelector("input[name=surname]");
        var _phoneNumber = form.querySelector('input[name=phone-number]');
        var _emailAddress = form.querySelector('input[name=email-address]');
        var _businessRegion = form.querySelector('select[name=business-region]');
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var _subject = form.querySelector("input[name=subject]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        var _postData = {
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'product': (_product ? _product.value : ''),
            'firstName': (_firstname ? _firstname.value : ''),
            'surname': (_surname ? _surname.value : ''),
            'contactNumber': (_phoneNumber ? _phoneNumber.value : ''),
            'emailAddress': (_emailAddress ? _emailAddress.value : ''),
            'region': (_businessRegion ? _businessRegion.value : ''),
            'bestTimeToCall': _date && _time ? _date.value + " " + _time.value : 'anytime',
            'dataPrivacyConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharingWithThirdPartiesMarketingConsent': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingAcrossBordersWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-boarders'),
            'formLocation': this.formLocationService.getLocation(),
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/legal-sector-lead";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (pResponse) {
            if (pResponse.data === "invalid") {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", pResponse.code);
                _this.dtmVirtualPage('thank you');
                _this.showDisplayView("success");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    LegalPractitionerForm.prototype.dtmVirtualPage = function (pPageNameNew) {
        dataLayer.pageName =
            "business:products and services:borrow for your needs:business banking solutions for legal practitioners :" +
                pPageNameNew;
        if (typeof _satellite == "object") {
            _satellite.track("globalVirtualPageView");
        }
    };
    LegalPractitionerForm.prototype.validateDate = function (_setDate) {
        if (_setDate === void 0) { _setDate = ''; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        var _currentHour = _currentDateTime.getHours();
        var _currentMin = _currentDateTime.getMinutes();
        if (_setDate !== '') {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate !== _tmpCurrentDate) {
                _currentHour = 7;
                _currentMin = 0;
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        if (_currentHour >= 16) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
            _currentMin = 0;
        }
        if ((_currentMin >= 30) && (_currentHour <= 15)) {
            _currentHour++;
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if ((_currentMin >= 30) && (_currentHour >= 15)) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
        }
        var _currentDayBefore = _currentDateTime.getDay();
        if (_currentDayBefore === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate === holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay === 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay === 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
                    _currentHour = 7;
                    _currentMin = 0;
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var item = this.formTimePicker;
        var _tmpTime = ((_currentHour >= 10) ? (_currentHour + ':00:00') : ('0' + _currentHour + ':00:00'));
        for (var i = item.options.length - 1; i >= 0; i--) {
            if (item.options[i].value !== 'Anytime') {
                if ((item.options[i].value < _tmpTime) && (_enabledOptions === false)) {
                    // item.options[i].disabled = true;
                }
                else if (_enabledOptions === true) {
                    item.options[i].disabled = false;
                }
            }
        }
        return _currentDateTime;
    };
    LegalPractitionerForm.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
        }
        else {
            // this.analyticsService.dtmFormComplete(`complete`, `true`);
            // this.analyticsService.completeDtmApplication();
        }
        this.form.reset();
        window.location.href = '/southafrica/business/products-and-services/business-solutions/industry/legal-professional-solutions';
    };
    LegalPractitionerForm.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    LegalPractitionerForm.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    return LegalPractitionerForm;
}(Base));
export { LegalPractitionerForm };



//////////////////
// WEBPACK FOOTER
// ./components/legal-practitioner-form/legal-practitioner-form.component.ts
// module id = 749
// module chunks = 0